export default __webpack_public_path__ + "static/media/mag5.56296485.png";